import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/more.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6f2ccb50"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "QaPicker"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});
var _hoisted_3 = {
  "class": "list"
};
var _hoisted_4 = ["onClick"];
import { ref, computed, unref } from 'vue';
export default /*#__PURE__*/_defineComponent({
  props: {
    title: String,
    modelValue: [String, Number],
    options: Array
  },
  emits: ['update:modelValue'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var label = computed(function () {
      var _unref$find;
      return ((_unref$find = unref(props.options || []).find(function (item) {
        return item.value === unref(props.modelValue);
      })) === null || _unref$find === void 0 ? void 0 : _unref$find.label) || '';
    });
    var visible = ref(false);
    var handleAction = function handleAction() {
      visible.value = true;
    };
    var checked = function checked(value) {
      visible.value = false;
      emit('update:modelValue', value);
    };
    var onCancel = function onCancel() {
      visible.value = false;
    };
    return function (_ctx, _cache) {
      var _component_van_action_sheet = _resolveComponent("van-action-sheet");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        "class": "title",
        onClick: handleAction
      }, [_createElementVNode("p", null, _toDisplayString(__props.title), 1), _createElementVNode("span", null, _toDisplayString(_unref(label)), 1)]), _hoisted_2, _createVNode(_component_van_action_sheet, {
        show: visible.value,
        "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
          return visible.value = $event;
        }),
        "close-on-click-action": ""
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, function (item) {
            return _openBlock(), _createElementBlock("div", {
              "class": _normalizeClass(["item", {
                'active': __props.modelValue === item.value
              }]),
              onClick: function onClick($event) {
                return checked(item.value);
              },
              key: item.label
            }, _toDisplayString(item.label), 11, _hoisted_4);
          }), 128))]), _createElementVNode("div", {
            "class": "cancel",
            onClick: onCancel
          }, "取消")];
        }),
        _: 1
      }, 8, ["show"])]);
    };
  }
});